<ng-container *ngIf="formGroup" [formGroup]="formGroup">
    <div class="p-2">
        <div class="row pb-2" *ngIf="formGroup.get('isPack')">
            <label class="col-3 mt-2 text-end mogo-bold">Pack is Required:</label>
            <div class="col-1 mt-1">
                <input type="checkbox" formControlName="isPack" />
            </div>
        </div>

        <div class="row pb-2" *ngIf="formGroup.get('plannedPackType') && formGroup.get('isPack')!.value">
            <label class="col-3 mt-2 text-end mogo-bold" for="plannedPackTypeDropDown">Pack Type</label>
            <div class="col-9">
                <ng-select id="plannedPackTypeDropDown" formControlName="plannedPackType"
                    [items]="availablePackTypes$ | async" bindLabel="name" placeholder="Select Pack Type">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="text-md-start">
                            {{ item.name }}
                        </div>
                    </ng-template>
                </ng-select>
            </div>
        </div>

        <div class="row pb-2" *ngIf="getFormPartial('plannedPackDate') && getFormPartial('isPack')!.value">
            <label class="col-3 mt-2 text-end mogo-bold">Planned Pack Date:</label>
            <div class="col-9">
                <app-custom-date-range-picker id="plannedPackDate" [formControl]="getFormPartial('plannedPackDate')"
                    placeholder="Select Planned Pack date">
                </app-custom-date-range-picker>
            </div>
        </div>
    </div>
</ng-container>